/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type ShowManagementListShowForSelectRequest = {
    perPage?: number | null;
    page?: number | null;
    keyword?: string | null;
    sort?: string | null;
    direction?: ShowManagementListShowForSelectRequest.direction | null;
    type?: string | null;
    title?: string | null;
};

export namespace ShowManagementListShowForSelectRequest {

    export enum direction {
        ASC = 'asc',
        DESC = 'desc',
    }


}

